import aspida from '@aspida/axios'
import api from '../../api/$api'

import {
  QuestionAnswerEntity,
  QuestionnaireAnswerEntity,
  UpdateQuestionnaireAnswerDto,
  UpdateQuestionAnswerDto,
} from '../../api/@types'
import { Methods } from '../../api/questionnaire-answer'

export const getQuestionnaireAnswers = async (
  query: Methods['get']['query'],
): Promise<QuestionnaireAnswerEntity[]> => {
  const client = api(aspida())

  try {
    const result = await client.questionnaire_answer.$get({ query })
    return result
  } catch {
    throw new Error('error.questionnaireAnswer.getQuestionnaireAnswers')
  }
}

export const getQuestionnaireAnswer = async (
  id: number,
): Promise<QuestionnaireAnswerEntity> => {
  const client = api(aspida())

  try {
    const result = await client.questionnaire_answer._id(id).$get()
    return result
  } catch {
    throw new Error('error.questionnaireAnswer.getQuestionnaireAnswers')
  }
}

export const updateQuestionnaireAnswer = async (
  id: number,
  dto: UpdateQuestionnaireAnswerDto,
): Promise<QuestionnaireAnswerEntity> => {
  const client = api(aspida())

  try {
    const result = await client.questionnaire_answer._id(id).$put({ body: dto })
    return result
  } catch {
    throw new Error('error.questionnaireAnswer.getQuestionnaireAnswers')
  }
}

export const updateQuestionAnswer = async (
  id: number,
  dto: UpdateQuestionAnswerDto,
): Promise<QuestionAnswerEntity> => {
  const client = api(aspida())
  try {
    const result = await client.question_answer._id(id).$put({ body: dto })
    return result
  } catch {
    throw new Error('error.questionnaireAnswer.getQuestionnaireAnswers')
  }
}
